import { render, staticRenderFns } from "./staffAttendance.vue?vue&type=template&id=1acd07fc&scoped=true"
import script from "./staffAttendance.vue?vue&type=script&lang=js"
export * from "./staffAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd07fc",
  null
  
)

export default component.exports